const items = [
  "Electrical Infrastructure",
  "Industrial Plumbing",
  "Bespoke Furniture",
  "UK Realty Projects",
  "Radius Company · Noida",
  "RIMS Hospital · Manipur",
  "Est. 2019",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-white/10 bg-[#14171D] py-5" data-testid="marquee-strip">
      <div className="marquee-track flex w-max items-center gap-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="whitespace-nowrap font-display text-xl font-bold uppercase tracking-wide text-[#9CA3AF]">
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-[#FFFFFF]" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
};
